import { render, staticRenderFns } from "./NbaGameDaySection.vue?vue&type=template&id=35b3b45c&scoped=true"
import script from "./NbaGameDaySection.vue?vue&type=script&lang=js"
export * from "./NbaGameDaySection.vue?vue&type=script&lang=js"
import style0 from "./NbaGameDaySection.vue?vue&type=style&index=0&id=35b3b45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3b45c",
  null
  
)

export default component.exports